import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { IApiresponse } from "src/app/_models/common/request-response/apiresponse";
import { setHeader } from "src/app/_helpers/setRequestHeader";
import { ClaimsHeaderService } from "src/app/shared/claimsHeader/claims-header.service";
import { IClaimantRangeMasterResponse } from "src/app/_models/claimant-range/claimant-range";


@Injectable({
    providedIn: "root",
})

export class ClaimantRangeService {
    httpHeaders: HttpHeaders;
    constructor(
        private http: HttpClient,
        private claimsHeaderService: ClaimsHeaderService,
        private header: setHeader
    ) { }

    GetClaimantRangeMaster() {
        return this.http.get<IApiresponse<IClaimantRangeMasterResponse[]>>(
            `${environment.billingApiUrl}GetClaimantRangeMaster`, { headers: this.header.authorizationHeader() });
    }
}
